// 📁 Orders.jsx
import React from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import vi from "date-fns/locale/vi";
import { Container } from "@mui/material";
import useOrderLogic from "../hooks/useOrderLogic";
import OrderHeader from "../components/Orders/OrderHeader";
import OrderFilters from "../components/Orders/OrderFilters";
import OrderCards from "../components/Orders/OrderCards";
import OrderTable from "../components/Orders/OrderTable";
import OrderDialogs from "../components/Orders/OrderDialogs";

const Orders = () => {
    const logic = useOrderLogic();

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={vi}>
            <Container maxWidth="lg">
                <OrderHeader
                    isMobile={logic.isMobile}
                    totalOrders={logic.totalOrders}
                    onCreate={() => logic.setIsAddOrderDialogOpen(true)}
                />
                <OrderFilters
                    isMobile={logic.isMobile}
                    searchOrderCode={logic.searchOrderCode}
                    onSearchChange={(e) =>
                        logic.setSearchOrderCode(e.target.value)
                    }
                    anchorEl={logic.anchorEl}
                    openPopover={logic.openPopover}
                    id={logic.id}
                    onOpenFilters={logic.onOpenFilters}
                    onCloseFilters={logic.onCloseFilters}
                    onDateRangeChange={logic.handleDateRangeChange}
                    // cộng thêm toàn bộ props còn lại...
                    {...logic}
                />
                {logic.isMobile ? (
                    <OrderCards {...logic} />
                ) : (
                    <OrderTable {...logic} />
                )}
                <OrderDialogs {...logic} />
            </Container>
        </LocalizationProvider>
    );
};

export default Orders;
